module.exports = __webpack_public_path__ + "img/47.2534ea85.jpg";